import { render, staticRenderFns } from "./PolicyFormation.vue?vue&type=template&id=4c6b3e45&scoped=true&"
import script from "./PolicyFormation.vue?vue&type=script&lang=js&"
export * from "./PolicyFormation.vue?vue&type=script&lang=js&"
import style0 from "./PolicyFormation.vue?vue&type=style&index=0&id=4c6b3e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b3e45",
  null
  
)

export default component.exports